// Fallbacks only. The real values come from General Settings via
// /api/settings/site — change the business name there, not here.
//
// These defaults are deliberately generic. A specific brand baked in as a
// fallback is how a rebrand half-sticks: the old name keeps surfacing wherever
// settings have not loaded yet or a field is left blank.
export const DEFAULT_SITE_NAME = 'A2G Office';
// No bundled default image - an unconfigured logo renders via SiteLogo's
// generic placeholder instead of falling back to any specific artwork.
export const DEFAULT_LOGO_URL = '';
// Intentionally empty. An invented support address sends real customer mail
// into a black hole; components should hide contact links when this is blank.
export const DEFAULT_SUPPORT_EMAIL = '';

export const DEFAULT_LOGO_HEIGHT = 40;

export const buildSiteSettingsState = (payload = {}, loading = false) => ({
  siteName: payload.site_name || DEFAULT_SITE_NAME,
  siteUrl: payload.site_url || '',
  logoUrl: payload.logo_url || DEFAULT_LOGO_URL,
  faviconUrl: payload.favicon_url || '',
  pwaIconUrl: payload.pwa_icon_url || payload.logo_url || DEFAULT_LOGO_URL,
  // Header logo height in px, set in Dev -> General Settings -> Site
  // Information. Clamped here as well as server-side because this value is
  // written straight into an inline style.
  logoHeight: Math.min(160, Math.max(16, Number(payload.logo_height) || DEFAULT_LOGO_HEIGHT)),
  adminEmail: payload.admin_email || '',
  supportEmail: payload.support_email || DEFAULT_SUPPORT_EMAIL,
  maintenanceMode: Boolean(payload.maintenance_mode),
  debugMode: Boolean(payload.debug_mode),
  requireAccountForCheckout: Boolean(payload.require_account_for_checkout),
  requireEmailVerificationForRegistration: payload.require_email_verification_for_registration !== false,
  loading,
});
